import { BaseModel } from './base.model';
import { EmailModel } from './email.model';
import { AttachmentModel } from './attachment.model';
import { HeaderItemModel } from './header-item.model';
import { QuestionGroupModel } from './question-group.model';
import { HeaderDefaultModel } from './header-default.model';
import { InspectionPlanModel } from './inspection-plan.model';
import { ChecklistEndpointModel } from './checklist-endpoint.model';
import { ChecklistInspectionModel } from './checklist-inspection.model';
import { InstituteDepartamentModel } from './institute-departaments.model';

export class ChecklistModel extends BaseModel {

    name: string;
    version: string;
    description: string;
    conclusion_type: number;
    signature_level: number;

    // inspection_plan_ids: string;
    checklist_inspections: ChecklistInspectionModel[];
    checklist_endpoint: ChecklistEndpointModel;

    observation_visible: boolean;
    boolean_percentage_visible: boolean;
    weight: number;
    origin_id: number;
    previous_id: number;
    active: boolean;
    institute_departaments: InstituteDepartamentModel[];
    header_items: HeaderItemModel[];
    header_default: HeaderDefaultModel[];
    question_groups: QuestionGroupModel[];
    inspection_plans: InspectionPlanModel[] | any;
    attachments: AttachmentModel[];
    emails: EmailModel[];
    low_criticality: number;
    high_criticality: number;
    medium_criticality: number;

    logo: any;

    send_complete_email: boolean;
    send_unconformity_email: boolean;
    send_complete_email_est: boolean;
    send_unconformity_email_est: boolean;
    send_unconformity_email_only: boolean;

    constructor(checklist?: ChecklistModel) {
        super();
        this.name = checklist ? checklist.name || null : null;
        this.version = checklist ? checklist.version || null : null;
        this.description = checklist ? checklist.description || null : null;
        this.conclusion_type = checklist ? checklist.conclusion_type || null : null;
        this.signature_level = checklist ? checklist.signature_level || null : null;

        this.observation_visible = checklist ? checklist.observation_visible || false : false;
        this.send_complete_email = checklist ? checklist.send_complete_email || false : false;
        this.send_complete_email_est = checklist ? checklist.send_complete_email_est || false : false;
        this.send_unconformity_email = checklist ? checklist.send_unconformity_email || false : false;
        this.send_unconformity_email_est = checklist ? checklist.send_unconformity_email_est || false : false;
        this.send_unconformity_email_only = checklist ? checklist.send_unconformity_email_only || false : false;

        this.boolean_percentage_visible = checklist ? checklist.boolean_percentage_visible || false : false;
        this.institute_departaments = checklist ? checklist.institute_departaments || [] : [];
        this.header_items = checklist ? checklist.header_items || [] : [];
        this.question_groups = checklist ? checklist.question_groups || [] : [];
        this.inspection_plans = checklist ? checklist.inspection_plans || null : null;
        this.attachments = checklist ? checklist.attachments || null : null;
        this.emails = checklist ? checklist.emails || null : null;
        this.header_default = checklist ? checklist.header_default || [] : [];
        this.weight = checklist ? checklist.weight || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/checklist.model.ts